<template>
  <v-card class="pa-4 rounded-lg">
    <h3 class="text-center primary--text">{{ $t('Detalhes do Alerta') }}</h3>

    <v-btn icon absolute top right small dark>
      <v-icon color="primary" @click="$emit('close')">mdi-close</v-icon>
    </v-btn>

    <div class="pa-4 rounded-lg grey lighten-3 mt-2">
      <div>
        <strong class="primary--text">{{ $t('Identificação') }}: </strong>
        <span>{{ alert.number }}</span>
      </div>
      <div class="my-2">
        <strong class="primary--text">{{ $t('Número Anvisa') }}: </strong>
        <span>{{ alert.anvisaNumber }}</span>
      </div>
      <div>
        <strong class="primary--text">{{ $t('Data') }}: </strong>
        <span>{{ formatDate(alert.date) }}</span>
      </div>
    </div>

    <v-expansion-panels flat v-if="alert && alert.equipsWithSameAnvisaNumber">
      <v-expansion-panel class="grey rounded-lg lighten-3 mt-2">
        <v-expansion-panel-header>
          <b class="primary--text">
            {{ $t('Equipamentos afetados') }} ({{
              alert.equipsWithSameAnvisaNumber
                ? alert.equipsWithSameAnvisaNumber.length
                : ''
            }})
          </b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            style="width: 100%; font-size: 12px"
            flat
            v-for="(item, index) in alert.equipsWithSameAnvisaNumber"
            :key="item.id"
          >
            <div class="d-flex align-center">
              <div>
                <b>{{ $t('Identificação') }}:</b>
                {{ item.identification }}
                <br />

                <b>{{ $t('Equipamento') }}:</b>
                {{ item.name }}
                <br />

                <b>{{ $t('Número de série') }}:</b>
                {{ item.serialNumber }}
              </div>

              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    depressed
                    @click="addOs(item.id, item.serviceOrder)"
                    :color="getButtonColor(item)"
                  >
                    <v-icon :color="getIconColor(item)" v-if="item.serviceOrder"
                      >mdi-view-module</v-icon
                    >
                    <v-icon v-else>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <span v-if="item.serviceOrder">Acessar ordem de serviço</span>
                <span v-else> Abrir ordem de serviço para o alerta </span>
              </v-tooltip>
            </div>

            <hr
              class="ma-2 ml-0"
              v-if="index != alert.equipsWithSameAnvisaNumber.length - 1"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="grey rounded-lg lighten-3 mt-2">
        <v-expansion-panel-header class="primary--text">
          <b>
            {{ $t('Fabricantes afetados') }} ({{
              alert.equipsWithSameAnvisaNumber
                ? alert.equipsWithSameAnvisaNumber.filter(
                    (value, index, array) =>
                      array
                        .map((x) => x.manufacturer)
                        .indexOf(value.manufacturer) === index
                  ).length
                : ''
            }})
          </b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            style="width: 100%; font-size: 12px"
            flat
            v-for="(item, index) in alert.equipsWithSameAnvisaNumber.filter(
              (value, index, array) =>
                array.map((x) => x.manufacturer).indexOf(value.manufacturer) ===
                index
            )"
            :key="item.id"
          >
            <b>{{ index + 1 }}</b> - {{ item.manufacturer }}

            <br />
            <v-divider class="my-1"></v-divider>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="grey rounded-lg lighten-3 mt-2">
        <v-expansion-panel-header class="primary--text">
          <b>{{ $t('Comentário') }} </b>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="institution.userType < 3 || institution.userType == 8"
                class="ma-1"
                style="
                  width: 50px;
                  min-width: 50px;
                  max-width: 50px;
                  padding: 0;
                "
                small
                color="#0F3565"
                dark
                @click.stop="openCommentDialog(alert)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon small>mdi-comment</v-icon>
              </v-btn>
            </template>
            {{
              this.alert.comments
                ? $t('Editar comentário')
                : $t('Adicionar comentário')
            }}
          </v-tooltip>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="this.alert.comments" style="width: 100%; font-size: 15px">
            <b>{{ this.alert.comments }}</b>
          </div>
          <div v-else>
            <p>{{ $t('Nenhum comentário disponível.') }}</p>
          </div>
          <div class="d-flex justify-end">
            <b style="color: grey; font-size: 12px"
              >{{ $t('Comentado por: ') }} "{{ this.alert.commentEditor }}"</b
            >
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="commentDialog" max-width="500">
      <v-card class="pt-3 rounded-lg">
        <h3 class="text-center primary--text">
          {{
            this.alert.comments
              ? $t('Editar comentário')
              : $t('Adicionar comentário')
          }}
        </h3>
        <v-card-text class="pl-5 pr-5">
          <v-textarea
            v-model="currentComment"
            outlined
            auto-grow
            hide-details
            rows="4"
            :label="$t('Comentário')"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-1 ml-2 secondary-button"
            depressed
            @click="commentDialog = false"
            >{{ $t('Cancelar') }}</v-btn
          >
          <v-btn
            :disabled="loading"
            class="ma-1 ml-2 primary-button"
            depressed
            @click="saveComment"
            >{{ $t('Salvar') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'

export default {
  props: {
    unidadeId: Number,
    id: Number,
  },

  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getDetail()
  },

  data() {
    return {
      alert: {},
      institution: {},
      alertTecnovigilancia: '',
      commentDialog: false,
      currentComment: '',
      loading: false,
      apiService: new ApiService(),
      userLogged: {},
    }
  },

  name: 'DetailsModal',

  methods: {
    openCommentDialog(item) {
      this.currentComment = item.comments
      this.alertTecnovigilancia = item
      this.commentDialog = true
    },

    async saveComment() {
      this.loading = true

      const payload = {
        alertId: this.alertTecnovigilancia.id,
        comment: this.currentComment,
        commentEditor: this.userLogged.name,
      }

      await this.apiService
        .post(`Tecnovigilancia/comment`, payload)
        .then((response) => {
          if (response.statusCode === 200) {
            this.$toast.success('Comentário adicionado com sucesso')

            this.$emit('comment-added', {
              itemId: this.alertTecnovigilancia.id,
              comment: this.currentComment,
            })
            this.commentDialog = false
          } else {
            this.$toast.error(
              response.message || 'Erro ao adicionar comentário teste.'
            )
          }
        })
        .catch(() => {
          this.$toast.error('Erro ao adicionar comentário')
        })
        .finally(() => {
          this.getDetail()
          this.loading = false
        })
    },

    getButtonColor(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.closeServiceOrderDateTime) {
          return 'secondary'
        }

        return '#F5F5F5'
      }
      return 'secondary'
    },

    getIconColor(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.closeServiceOrderDateTime) {
          return '#F5F5F5'
        }

        return 'secondary'
      }
      return '#F5F5F5'
    },

    getDetail() {
      this.apiService.get(`tecnovigilancia/${this.id}`).then((response) => {
        this.alert = response.content
        if (this.unidadeId) {
          this.alert.equipsWithSameAnvisaNumber =
            this.alert.equipsWithSameAnvisaNumber.filter(
              (x) => x.unidadeId == this.unidadeId
            )
        }
      })
    },

    addOs(id, order) {
      if (order) {
        const route = this.$router.resolve(`/editServiceOrder/${order.id}`)
        window.open(route.href, '_blank')
        return
      }

      const model = {
        alertId: this.alert.id,
        equipmentId: id,
      }

      this.apiService
        .post('tecnovigilancia/add-os', model)
        .then((response) => {
          const route = this.$router.resolve(
            `/editServiceOrder/${response.content}`
          )
          window.open(route.href, '_blank')

          this.$toast.success('Ordem de serviço cadastrada com sucesso!')
          this.$emit('close')
        })
        .catch(() => {})
    },

    formatDate(date) {
      return moment(date).format('DD/MM/yyyy')
    },
  },
}
</script>

<style scoped></style>
